/**
 * OrnamentDivider
 * -----------------------------------------------------------
 * A quiet break between sections: two gold hairlines that fade
 * out at their ends, with a small lotus motif in the middle.
 */
const LINE = {
  left:  "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.7) 100%)",
  right: "linear-gradient(90deg, rgba(201,169,97,0.7) 0%, rgba(201,169,97,0) 100%)",
};

export default function OrnamentDivider() {
  return (
    <div className="relative bg-ivory flex items-center justify-center gap-4 py-6" aria-hidden="true">
      <span className="h-px w-24 sm:w-40" style={{ background: LINE.left }} />
      <svg viewBox="0 0 40 24" className="w-10 h-6 text-gold" fill="none" stroke="currentColor" strokeWidth="1.1">
        <path d="M20 3 C24 8 24 15 20 21 C16 15 16 8 20 3Z" fill="rgba(201,169,97,0.18)" />
        <path d="M20 21 C14 19 9 15 7 9 C12 10 17 14 20 21Z" />
        <path d="M20 21 C26 19 31 15 33 9 C28 10 23 14 20 21Z" />
        <circle cx="20" cy="22.2" r="0.9" fill="currentColor" stroke="none" />
      </svg>
      <span className="h-px w-24 sm:w-40" style={{ background: LINE.right }} />
    </div>
  );
}
